import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MapPin, CalendarDays, Users, Search } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { api, addMonths, toISO } from "@/lib/api";
import { toast } from "sonner";

export default function SearchBar({ initial = {}, compact }) {
  const { t } = useLang();
  const nav = useNavigate();
  const [cities, setCities] = useState([]);
  const [f, setF] = useState({ city: initial.city || "", check_in: initial.check_in || "", check_out: initial.check_out || "", guests: initial.guests || "1" });
  useEffect(() => { api.get("/listings/cities").then((r) => setCities(r.data)).catch(() => {}); }, []);
  const today = toISO(new Date());
  const set = (k) => (e) => {
    const v = e.target.value;
    setF((p) => {
      const n = { ...p, [k]: v };
      if (k === "check_in" && v && (!p.check_out || p.check_out < addMonths(v, 1))) n.check_out = addMonths(v, 1);
      return n;
    });
  };
  const submit = (e) => {
    e.preventDefault();
    if (f.check_in && f.check_out && f.check_out < addMonths(f.check_in, 1)) return toast.error(t("min_month_hint"));
    const p = new URLSearchParams(Object.entries(f).filter(([, v]) => v));
    nav(`/search?${p.toString()}`);
  };
  const box = "flex items-center gap-3 rounded-xl bg-slate-50 border border-slate-200 px-3.5 h-14 focus-within:border-[#FF6B00] focus-within:bg-white transition-colors";
  const lbl = "block text-[10px] font-bold uppercase tracking-[0.14em] text-slate-500";
  const inp = "w-full bg-transparent text-sm font-semibold text-[#0B192C] outline-none placeholder:text-slate-400";
  return (
    <form onSubmit={submit} className={`grid gap-2.5 ${compact ? "md:grid-cols-[1.4fr_1fr_1fr_0.7fr_auto]" : "lg:grid-cols-[1.4fr_1fr_1fr_0.7fr_auto]"}`} data-testid="search-form">
      <div className={box}>
        <MapPin className="h-5 w-5 shrink-0 text-[#FF6B00]" />
        <div className="w-full"><span className={lbl}>{t("city")}</span>
          <input list="htb-cities" value={f.city} onChange={set("city")} placeholder={t("city_ph")} className={inp} data-testid="search-city-input" />
          <datalist id="htb-cities">{cities.map((c) => <option key={c} value={c} />)}</datalist>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-2.5 lg:contents">
        <div className={box}>
          <CalendarDays className="h-5 w-5 shrink-0 text-[#FF6B00]" />
          <div className="w-full"><span className={lbl}>{t("check_in")}</span>
            <input type="date" min={today} value={f.check_in} onChange={set("check_in")} className={inp} data-testid="search-checkin-input" /></div>
        </div>
        <div className={box}>
          <CalendarDays className="h-5 w-5 shrink-0 text-[#FF6B00]" />
          <div className="w-full"><span className={lbl}>{t("check_out")}</span>
            <input type="date" min={f.check_in ? addMonths(f.check_in, 1) : today} value={f.check_out} onChange={set("check_out")} className={inp} data-testid="search-checkout-input" /></div>
        </div>
      </div>
      <div className={box}>
        <Users className="h-5 w-5 shrink-0 text-[#FF6B00]" />
        <div className="w-full"><span className={lbl}>{t("guests")}</span>
          <input type="number" min="1" max="20" value={f.guests} onChange={set("guests")} className={inp} data-testid="search-guests-input" /></div>
      </div>
      <button type="submit" className="h-14 rounded-xl bg-[#FF6B00] px-7 font-bold text-white hover:bg-[#E05A00] active:scale-[0.98] transition-[background-color,transform] flex items-center justify-center gap-2" data-testid="search-submit-btn">
        <Search className="h-5 w-5" />{t("search")}
      </button>
    </form>
  );
}
